/**
 * Component showing the parameters of AI Music Detector on the home page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025.
 */

import { useEffect, useState } from 'react'
import { Tooltip } from 'react-tooltip'
import IosSwitch from '../../IosSwitch'
import ModuleConfigList from '../../ModuleConfig/ModuleConfigList'
import { ModuleKey } from '../../ModuleConfig/ModuleInfo'
import '../styles/homemodule.css'
import './styles/ai-music-detector-param.css'

const IOS_SWITCH_HEIGHT = 17
const IOS_SWITCH_WIDTH = 30

export interface AiMusicDetectorParamProps {
  updateModuleParamList: (newParam: Record<string, any>) => void
}

const AiMusicDetectorParamComp = (props: AiMusicDetectorParamProps) => {
  const [isTimeAnalysisEnabled, setTimeAnalysisEnabled] = useState(false)
  // TODO: Enable stem analyzis when backend is ready
  // const [isStemAnalysisEnabled, setStemAnalysisEnabled] = useState(false)

  // The list of options of the module parameter
  const paramGroupDef =
    ModuleConfigList[ModuleKey.AiMusicDetector].paramList?.[0] || null
  // The time analysis parameter option
  const paramDefTimeAnalysis = paramGroupDef?.options?.[0] || null
  const paramNameTimeAnalysis = paramDefTimeAnalysis?.name ?? 'param0'

  useEffect(() => {
    props.updateModuleParamList({
      [paramNameTimeAnalysis]: isTimeAnalysisEnabled,
    })
  }, [isTimeAnalysisEnabled])

  return (
    <div className="param-comp ai-music-detector-param">
      <div className="param-label">
        <div>Additional analysis</div>
        <img
          data-tooltip-id="home-ai-music-detector-tooltip-param"
          data-tooltip-place="bottom"
          src="/icon/question-mark.svg"
          width="16px"
          height="16px"
        />
      </div>

      <div className="switch-container">
        <div className="param-switch">
          <IosSwitch
            id="switch-time-analysis"
            height={IOS_SWITCH_HEIGHT}
            width={IOS_SWITCH_WIDTH}
            checked={isTimeAnalysisEnabled}
            onChange={(e) => setTimeAnalysisEnabled(e.target.checked)}
            label={<div>Time analysis</div>}
          />
        </div>

        {/* // TODO: Enable stem analyzis when backend is ready
        <div className="param-switch">
          <IosSwitch
            height={14}
            width={24}
            checked={isStemAnalysisEnabled}
            onChange={(e) => setStemAnalysisEnabled(e.target.checked)}
          />
          <div>
            Stem analysis <span className="cost">(0.05 extra credits)</span>
          </div>
        </div> */}
      </div>

      <Tooltip
        id="home-ai-music-detector-tooltip-param"
        content="Analysis of the evolution over time"
        className="tooltip"
      />
    </div>
  )
}

export default AiMusicDetectorParamComp
